import { leagueSeasonListResponseSchema, leagueSeasonSchema } from "../../schemas/leagues";
import type { StartLeagueSeason } from "../../types";
import { fetchApi } from "../internal";

export const seasons = {
	// Staff only; idempotent on an already-closed season.
	close: (leagueId: string, seasonId: string) =>
		fetchApi(`/leagues/${leagueId}/seasons/${seasonId}/close`, leagueSeasonSchema, {
			method: "POST",
		}),
	// Newest first; any active club member can read it.
	list: (leagueId: string) =>
		fetchApi(`/leagues/${leagueId}/seasons`, leagueSeasonListResponseSchema),
	// Staff only. Closes the open season (voiding unsettled results) and opens
	// season N+1. 409 `season_not_active` if the league is archived.
	start: (leagueId: string, data?: StartLeagueSeason) =>
		fetchApi(`/leagues/${leagueId}/seasons`, leagueSeasonSchema, {
			body: JSON.stringify(data ?? {}),
			method: "POST",
		}),
};
